
import React, { useState, useEffect } from 'react';
import useFetch from './hooks/useFetch';
import { signIn, confirmSignIn } from 'aws-amplify/auth';
import { ADMIN_CONFIRM_EMAIL } from './constants/api';


export default function DefinePassword({ user, email, oldPassword, onPasswordDefined, setRedirect }) {
    const [password, setPassword] = useState(oldPassword);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [seeCurrentPassword, setSeeCurrentPassword] = useState(false);
    const [seeNewPassword, setSeeNewPassword] = useState(false);
    const [seeConfirmPassword, setSeeConfirmPassword] = useState(false);
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        if (!password || !newPassword || !confirmPassword) {
            setError('Preencha todos os campos.');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('As senhas não coincidem.');
            return;
        }
        try {
            if (!email || !newPassword) {
                setError('Email e nova senha são obrigatórios.');
                return;
            }

            if (!user) {
                setError('Usuário não encontrado para alteração de senha.');
                return;
            }
            let data = {
                username: email,
                password: password
            };

            signIn(data)
                .then(res => {
                    if (res.nextStep && res.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
                        confirmSignIn({
                            challengeResponse: confirmPassword,
                        }).then(data => {
                            console.log("Senha alterada com sucesso: ", data);
                            onPasswordDefined(password);
                            // se der bom, envia para a rota /admin/planos-do-usuario
                            setRedirect(true);
                            window.location.reload();
                        }).catch(err => {
                            console.error("Erro ao alterar senha: ", err);
                            setError(err.message || 'Erro ao alterar senha.');
                        });
                    } else {
                        setError('');
                    }
                })
                .catch(err => {
                    setError(err.message);
                });
        } catch (err) {
            setError("Erro!\n" + (err.message || 'Erro ao redefinir senha.'));
        }
    };

    return (
        <div style={{ maxWidth: 400, margin: '40px auto', padding: 24, border: '1px solid #eee', borderRadius: 8 }}>
            <h1 style={{ textAlign: 'center' }}>Definir nova senha</h1>
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 16 }}>
                    <label htmlFor="password">Senha ANTIGA</label>
                    <input
                        type={seeCurrentPassword ? "text" : "password"}
                        id="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        style={{ width: '100%', padding: 8, marginTop: 4 }}
                        autoComplete="current-password"
                    />
                    <a href="#" onClick={() => setSeeCurrentPassword(!seeCurrentPassword)} style={{ fontSize: 12, marginTop: 4, display: 'block' }}>{seeCurrentPassword ? 'Ocultar senha' : 'Ver senha'}</a>
                </div>
                <div style={{ marginBottom: 16 }}>
                    <label htmlFor="newPassword">Nova senha</label>
                    <input
                        type={seeNewPassword ? "text" : "password"}
                        id="newPassword"
                        value={newPassword}
                        onChange={e => setNewPassword(e.target.value)}
                        style={{ width: '100%', padding: 8, marginTop: 4 }}
                        autoComplete="new-password"
                    />
                    <a href="#" onClick={() => setSeeNewPassword(!seeNewPassword)} style={{ fontSize: 12, marginTop: 4, display: 'block' }}>{seeNewPassword ? 'Ocultar senha' : 'Ver senha'}</a>

                </div>
                <div style={{ marginBottom: 16}}>
                    <label htmlFor="confirmPassword">Confirme nova senha</label>
                    <input
                        type={seeConfirmPassword ? "text" : "password"}
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={e => setConfirmPassword(e.target.value)}
                        style={{ width: '100%', padding: 8, marginTop: 4 }}
                        autoComplete="new-password"
                    />
                    <a href="#" onClick={() => setSeeConfirmPassword(!seeConfirmPassword)} style={{ fontSize: 12, marginTop: 4, display: 'block' }}>{seeConfirmPassword ? 'Ocultar senha' : 'Ver senha'}</a>
                </div>
                {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
                {success && <div style={{ color: 'green', marginBottom: 12 }}>{success}</div>}
                <button type="submit" style={{ width: '100%', padding: 10, background: '#0070f3', color: '#fff', border: 'none', borderRadius: 4, fontWeight: 'bold' }}>
                    Redefinir senha
                </button>
            </form>
        </div>
    );
}
